module.exports = __webpack_public_path__ + "static/media/check_might.13287978.png";